import React from "react";
import "./Gdsph.css";

const PRODUCTS = [
  {
    id: 1,
    name: "[100] Bao Lì Xì Lần 6 Ngăn",
    price: 6000,
    href: "#",
    img: "/1sph/1.jpeg",
    badgeText: "Tạm hết",
    badgeTone: "danger",
    qtyPrefix: "[100]",
  },
  {
    id: 2,
    name: "[56] Thố Sứ 8inch Có Tay Cầm MIX MÀU",
    price: 35200,
    href: "#",
    img: "/1sph/2.jpeg",
    qtyPrefix: "[56]",
  },
  {
    id: 3,
    name: "[50] Khăn Ướt Lau Bàn Thờ",
    price: 7600,
    href: "#",
    img: "/1sph/3.jpeg",
    qtyPrefix: "[50]",
  },
  {
    id: 4,
    name: "[-] Set 100 Bao Lì Xì Truyền Thống",
    price: 25200,
    href: "#",
    img: "/1sph/4.jpeg",
    qtyPrefix: "[-]",
    badgeText: "Hot",
    badgeTone: "hot",
  },
  {
    id: 5,
    name: "[12] Cành Đào Mini Trang Trí Tết",
    price: 49000,
    href: "#",
    img: "/1sph/5.jpeg",
    qtyPrefix: "[12]",
  },
  {
    id: 6,
    name: "[30] Tượng Thần Tài Mini (84g)",
    price: 18900,
    href: "#",
    img: "/1sph/6.jpeg",
    qtyPrefix: "[30]",
    badgeText: "Sale",
    badgeTone: "sale",
  },
  {
    id: 7,
    name: "[20] Khăn Giấy Hộp Cao Cấp",
    price: 32900,
    href: "#",
    img: "/1sph/7.jpeg",
    qtyPrefix: "[20]",
  },
  {
    id: 8,
    name: "[60] Bộ Bao Lì Xì Đỏ May Mắn",
    price: 15900,
    href: "#",
    img: "/1sph/8.jpeg",
    qtyPrefix: "[60]",
  },
];

function formatVND(n) {
  // 6000 -> "6,000đ"
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
}

export default function Gdsph() {
  return (
    <section className="hp">
      <div className="hp__container">
        <h2 className="hp__title">SẢN PHẨM HOT</h2>

        <div className="hp__grid">
          {PRODUCTS.slice(0, 8).map((p) => (
            <a className="hp__card" href={p.href} key={p.id}>
              <div className="hp__media">
                <img
                  className="hp__img"
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                />

                {p.badgeText ? (
                  <span className={`hp__badge hp__badge--${p.badgeTone}`}>
                    {p.badgeText}
                  </span>
                ) : null}

                {/* icon góc trái như ảnh (tuỳ chọn) */}
                <span className="hp__cornerIcon" aria-hidden="true" />
              </div>

              <div className="hp__meta">
                <div className="hp__name">
                  <span className="hp__qty">{p.qtyPrefix}</span>{" "}
                  <span className="hp__nameText">
                    {p.name.replace(/^\[[^\]]+\]\s*/, "")}
                  </span>
                </div>
                <div className="hp__price">{formatVND(p.price)}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
